var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVirtualAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0584 11.9167L17.725 16.0833C17.6 17.3583 17.5 18.3333 15.2417 18.3333H4.75836C2.50003 18.3333 2.40003 17.3583 2.27503 16.0833L1.9417 11.9167C1.87503 11.225 2.0917 10.5833 2.48336 10.0917C2.4917 10.0833 2.4917 10.0833 2.50003 10.075C2.95836 9.51667 3.65003 9.16667 4.42503 9.16667H15.575C16.35 9.16667 17.0334 9.51667 17.4834 10.0583C17.4917 10.0667 17.5 10.075 17.5 10.0833C17.9084 10.575 18.1334 11.2167 18.0584 11.9167Z",
    stroke: "#5444F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91669 9.525V5.23333C2.91669 2.4 3.62502 1.69167 6.45835 1.69167H7.51669C8.57502 1.69167 8.81669 2.00833 9.21669 2.54167L10.275 3.95833C10.5417 4.30833 10.7 4.525 11.4084 4.525H13.5334C16.3667 4.525 17.075 5.23333 17.075 8.06667V9.55833",
    stroke: "#5444F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85834 14.1667H12.1417",
    stroke: "#5444F2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualAccount);
export default __webpack_public_path__ + "static/media/virtual-account.e402f080e41191c1ddc63c1ebeea0bb9.svg";
export { ForwardRef as ReactComponent };